module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/round-4f5439b12cf7a8227dd10a3e0bcff315.png";